import React from 'react';
import SEO from '../components/SEO';
import ContactForm from '../components/ContactForm';
import ContactBoxes from '../components/ContactBoxes';
import { COMPANY_INFO } from '../data/mockData';

export default function ContactPage() {
  return (
    <div className="space-y-16 pb-16">
      <SEO 
        title="Kontakt | K-TO Multiservice ApS | Hent uforpligtende tilbud"
        description="Skal vi arbejde på din ventilation? - Kontakt K-TO Multiservice i dag og lad os høre om din opgave. Vi kører på hele Jylland og Fyn."
        slug="/kontakt"
        image="https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-8-1024x683.jpg"
        exact={true}
      />

      {/* Header */}
      <section className="bg-slate-900 text-white py-16 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-sky-500/20 text-sky-300 text-xs font-bold uppercase tracking-wider border border-sky-500/30">
            <i className="fa-solid fa-address-book text-sky-400" aria-hidden="true"></i>
            <span>Kontakt os</span>
          </div>

          <h1 className="text-3xl sm:text-5xl font-black tracking-tight text-white">
            Kontakt K-TO Ventilationsteknik
          </h1>

          <p className="text-slate-300 text-base sm:text-lg max-w-3xl leading-relaxed">
            Hør mere om vores ydelser, eller indhent et uforpligtende tilbud på service, indregulering, rensning eller fejlfinding på Fyn og i Jylland.
          </p>
        </div>
      </section>

      {/* Main Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          {/* Company Details Column */}
          <div className="lg:col-span-5 space-y-8">
            <div className="bg-white rounded-3xl p-8 border border-slate-200 shadow-sm space-y-6">
              <h2 className="text-2xl font-extrabold text-slate-900 tracking-tight">
                Virksomhedsoplysninger
              </h2>

              <div className="space-y-5 text-sm">
                <div>
                  <span className="text-xs uppercase font-bold text-slate-400 tracking-wider block mb-1">
                    Firmanavn
                  </span>
                  <p className="text-lg font-bold text-slate-900">{COMPANY_INFO.brandName}</p>
                  <p className="text-xs text-slate-500">Juridisk navn: {COMPANY_INFO.legalName}</p>
                  <p className="text-xs text-slate-500">CVR-nr.: {COMPANY_INFO.cvr}</p>
                </div>

                <div className="pt-3 border-t border-slate-100">
                  <span className="text-xs uppercase font-bold text-slate-400 tracking-wider block mb-1">
                    Adresse
                  </span>
                  <p className="font-semibold text-slate-800">{COMPANY_INFO.address}</p>
                  <p className="text-slate-600">{COMPANY_INFO.zipCity} - Danmark</p>
                </div>

                <div className="pt-3 border-t border-slate-100">
                  <span className="text-xs uppercase font-bold text-slate-400 tracking-wider block mb-1">
                    Telefon
                  </span>
                  <a 
                    href={`tel:${COMPANY_INFO.phoneRaw}`}
                    className="text-xl font-extrabold text-sky-600 hover:text-sky-700 transition-colors block nowrap-contact"
                  >
                    {COMPANY_INFO.phone}
                  </a>
                  <span className="text-xs text-slate-500">Kører i hele Jylland & Fyn</span>
                </div>

                {/* VISUALLY DISTINGUISHED EMAILS */}
                <div className="pt-3 border-t border-slate-100 space-y-4">
                  {/* Generelle henvendelser */}
                  <div className="p-4 rounded-xl bg-sky-50/80 border border-sky-200/80 space-y-1">
                    <span className="block text-xs uppercase font-extrabold text-sky-900 tracking-wider">
                      Generelle henvendelser
                    </span>
                    <p className="text-xs text-sky-800 mb-1">
                      Brug denne adresse til alle forespørgsler, tilbud og serviceaftaler:
                    </p>
                    <a 
                      href={`mailto:${COMPANY_INFO.email}`} 
                      className="text-base font-extrabold text-sky-700 hover:text-sky-900 transition-colors block nowrap-contact"
                    >
                      {COMPANY_INFO.email}
                    </a>
                  </div>

                  {/* Fakturaer */}
                  <div className="p-4 rounded-xl bg-emerald-50/80 border border-emerald-200/80 space-y-1">
                    <span className="block text-xs uppercase font-extrabold text-emerald-900 tracking-wider">
                      Fakturaer
                    </span>
                    <p className="text-xs text-emerald-800 mb-1">
                      Brug udelukkende denne adresse til indsendelse af fakturaer og bilag:
                    </p>
                    <a 
                      href={`mailto:${COMPANY_INFO.invoiceEmail}`} 
                      className="text-base font-extrabold text-emerald-700 hover:text-emerald-900 transition-colors block nowrap-contact"
                    >
                      {COMPANY_INFO.invoiceEmail}
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* Interactive Form Column */}
          <div className="lg:col-span-7">
            <ContactForm />
          </div>

        </div>
      </section>
    </div>
  );
}
